import React from "react";
import { Link, useLocation } from "react-router-dom";
import { SITE_ORIGIN } from "../data/site";
type SiteLinkProps = {
  path: string;
  className?: string;
  children: React.ReactNode;
  onClick?: () => void;
};
export function SiteLink({
  path,
  className,
  children,
  onClick
}: SiteLinkProps) {
  const location = useLocation();
  if (path.startsWith("/#") && location.pathname === "/") {
    return <a href={path.slice(1)} className={className} onClick={onClick} data-id="element-354" data-mp="3gr8s77p3yvi">{children}</a>;
  }
  if (path === "/" || path.startsWith("/#") || path === "/cases" || path.startsWith("/cases/") || path === "/events" || path.startsWith("/events/")) {
    return <Link to={path} className={className} onClick={onClick} data-id="element-355" data-mp="3qntamiywc9jw">{children}</Link>;
  }
  return <a href={`${SITE_ORIGIN}${path}`} target="_blank" rel="noopener" className={className} onClick={onClick} data-id="element-356" data-mp="3viyxbk04hs91">
      {children}<span className="sr-only" data-id="element-357" data-mp="2k5myxon4u1u9"> (opens in a new tab)</span>
    </a>;
}